import { render, staticRenderFns } from "./MaybeShipped.vue?vue&type=template&id=23f48cfb&"
import script from "./MaybeShipped.vue?vue&type=script&lang=js&"
export * from "./MaybeShipped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports